<template>
  <CustomSelect 
    v-model="internalSelectedCountry"
    :items="countriesListItems"
    :displaySearch="true"
    placeholder="Select country"
    class="select-country"
    @update:query="filterCountriesListItems"
    @update:modelValue="$emit('select', $event)"
  />
</template>

<script lang="ts">
import { Vue, Options, prop } from 'vue-class-component'
import countriesList from '@/assets/countries/list.json';

import CustomSelect from '@/components/UIElements/CustomSelect.vue'
import { ListItem } from '@/components/UIElements/List.vue';
import { Watch } from 'vue-property-decorator';


class Props {
  selectedCountry?: ListItem | null = prop({
    required: false,
  });
}

@Options({
  components: {
    CustomSelect
  },
})
export default class CountrySelector extends Vue.with(Props) {
  internalSelectedCountry:ListItem | null = null;
  countriesListItems:ListItem[] = countriesList.map((country) => {
    return {
      text: country.name,
      value: country.key,
      flag: country.key.toLowerCase(),
      meta: {
        latitude: country.latitude,
        longitude: country.longitude,
      },
    }
  });
  filterCountriesListItems(query: string): void {
    this.countriesListItems = countriesList
      .filter(country => (country.name && country.name.toLowerCase().includes(query.toLowerCase())) || (country.key && country.key.toLowerCase().includes(query.toLowerCase())))
      .map(country => ({
        text: country.name,
        value: country.key,
        flag: country.key.toLowerCase(),
        meta: {
          latitude: country.latitude,
          longitude: country.longitude,
        }
      }));
  }

  @Watch('selectedCountry')
  onSelectedCountryChange() {
    this.internalSelectedCountry = this.selectedCountry || null;
  }

}
</script>